import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { MQTTOperation } from 'src/app/Service/mqttoperation.service';
import { GenericValidator } from 'src/app/validation/general-validation';
import { DatePipe, formatDate } from '@angular/common';
import { UploadFileComponent } from '../upload-file/upload-file.component';
import { ConfirmDialogComponent } from 'src/app/Common/confirm-dialog/confirm-dialog.component';
import { ConfigurationsService } from 'src/app/Service/configurations.service';
import { AlertMasterService } from 'src/app/Service/alertmaster.service';
import { AddnewparameterconfigComponent } from '../addnewparameterconfig/addnewparameterconfig.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-config-parameter',
  templateUrl: './registerpanel.html'
})
export class RegisterpanelComponent implements OnInit {
  showvalue: any = false
  ModbusRequestTypeList: any = [];
  isSaveClick: boolean = false;
  IsreadOnly: boolean = false;
  DisplayButton: boolean = false;
  RoleName: string = '';
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;
  displayMessage: { [key: string]: string } = {};
  private ListvalidationMessages: { [key: string]: { [key: string]: string } };
  private ListgenericValidator: GenericValidator;
  ListdisplayMessage: { [key: string]: string } = {};
  RegisterData: [];
  registerpanelForm: FormGroup;
  deviceSettingsForm: FormGroup
  DropDownList: any;
  errorMsg: string = '';
  successMsg: string = '';
  errorMsgdevice: string = '';
  successMsgdevice: string = '';
  DatatypeList: [] = [];
  DecimalPointList: [];
  FunctionCodeList: [];
  DecimalPointFrontList: [];
  UserPrefData: any[] = [];
  minSlID: number = 0;
  maxSlID: number = 0;
  SlaveMessage: string = '';
  EnergyMeterdata: any = [];
  listRegisterdata: any;
  flag: boolean = true;
  numberOfRegister: any;
  EnergyMeterID: any;
  PublishRegisterJson: any[] = [];
  MaximumRegister: number = 0;
  List: any[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
  MaxRegister: string = '';
  DeviceProtocol: any = '';
  EMIndex: number = 0;
  KeyID: string = '';
  IsChange: boolean = true;
  isSaved: boolean = false;
  ActionList: any[] = [];
  ReqObj: { [key: string]: any } = {};
  RNameObj: { [key: string]: any } = {};
  selectedmetername: any
  selectedmeterid: any
  energyListOfPopup: any = []
  newdata: any;
  Addformulamsg: string;
  isDivVisible: boolean = false
  DataReadSelectionList: any = []
  UnitList: any = []
  AlertList: any = []
  defaultAlertId: any = 1
  CompanyCode: any
  CalibrationCertificatefilename: any;
  meterConfiguration: {
    SerialNumber: any; LastCalibrationDate: string; LastCalibrationDueDate: string; CalibrationCertificate: any; EnergymeterMasterId: any;
    UserId: string;
  };
  RegisterDataparam: any;
  MeterConfigurationdata: any;
  registeravailableornot: any

  normalizeAlertId(value: any): number {
    if (value == null || value === '' || value === 0 || value === '0') {
      return this.defaultAlertId;
    }
    return Number(value);
  }

  resolveAlertId(element?: any): number {
    return this.normalizeAlertId(element?.AlertId ?? this.EnergyMeterdata?.AlertId ?? this.defaultAlertId);
  }

  compareAlertId = (a: any, b: any): boolean => {
    if (a == null && b == null) {
      return true;
    }
    if (a == null || b == null) {
      return false;
    }
    return Number(a) === Number(b);
  };

  applyDefaultAlertIdsToRows(): void {
    const registerArray = this.registerpanelForm?.get('listRegisterdata') as FormArray;
    if (!registerArray) {
      return;
    }
    registerArray.controls.forEach((ctrl) => {
      const alertCtrl = ctrl.get('AlertId');
      if (alertCtrl) {
        const normalized = this.normalizeAlertId(alertCtrl.value);
        alertCtrl.setValue(normalized, { emitEvent: false });
      }
    });
  }

  constructor(public datepipe: DatePipe, private configService: ConfigurationsService, public fb: FormBuilder, private GSMConfigService: GSMConfigurationService, private alertMasterService: AlertMasterService, private authService: AuthService, private form: FormBuilder, private dialog: MatDialog, private mqttoperation: MQTTOperation, public dialogRef: MatDialogRef<RegisterpanelComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

    this.CompanyCode = localStorage.getItem("CompanyCode")
    dialogRef.disableClose = true;
    this.selectedmetername = data.EnergyMeterdata.selectedmetername
    if (data && data.EnergyMeterdata.RegisterData) {
      this.EnergyMeterdata = data.EnergyMeterdata.RegisterData;

      this.energyListOfPopup = data.EnergyMeterdata.RegisterData.listRegisterdata
    }
    if (data && data.EnergyMeterdata.meterConfiguration) {
      this.MeterConfigurationdata = data.EnergyMeterdata.meterConfiguration;
    }
    this.Addformulamsg = '*Please first save register data.'
    this.DeviceProtocol = typeof (data.EnergyMeterdata.DeviceProtocol) == 'string' ? data.EnergyMeterdata.DeviceProtocol : data.EnergyMeterdata.DeviceProtocol.SettingsData.DeviceProtocol;
    if (this.DeviceProtocol == 0) {
      this.DeviceProtocol = 'HTTP'
    }
    else if (this.DeviceProtocol == 1) {
      this.DeviceProtocol = 'FTP'
    }
    this.EnergyMeterID = data.EnergyMeterdata.EMID;
    this.EMIndex = data.EnergyMeterdata.EMIndex;
    this.KeyID = data.EnergyMeterdata.KeyID;

    // Raise Validation message
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.registerpanelForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });

    this.authService.getValidationMessage().subscribe(resp => {
      this.ListvalidationMessages = resp.listRegisterdata;
      this.ListgenericValidator = new GenericValidator(this.ListvalidationMessages);
    });
  }

  ngOnInit(): void {

    this.Getdropdownlist();

    if (this.RoleName == 'Admin') {
      this.DisplayButton = false;
      this.IsreadOnly = true;
      const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];
      control.disable();
    }
    else {
      this.DisplayButton = true;
      this.IsreadOnly = false;
    }
    this.isDivVisible = false
    this.deviceSettingsForm = this.form.group({
      SerialNumber: [''],
      LastCalibrationDate: [new Date()],
      LastCalibrationDueDate: [new Date()],
    })
    this.registerpanelForm = this.form.group({
      EnergymeterMasterID: [0],
      SlaveID: ['', [Validators.required]],
      MaxRegisters: ['', [Validators.required]],
      ReadRegisterQuantity: ['0', [Validators.required]],
      MaxSlaveRecord: ['', [Validators.required]],
      ModbusRequestType: ['0', [Validators.required]],
      StartRegisterNumber: ['0', [Validators.required]],
      DataReadSelection: ['', [Validators.required]],
      'listRegisterdata': this.form.array([this.fb.group({
        RegisterName: ['', [Validators.required]],
        RegisterNO: ['', [Validators.required]],
        DataType: ['', [Validators.required]],
        FunctionCode: ['', [Validators.required]],
        DecimalPoint: ['', [Validators.required]],
        ReadWriteAction: ['', [Validators.required]],
        IsDisplayGraph: [''],
        IsTotalizer: [''],
        AlertId: [1, [Validators.required]],
        HighThresoldValue: [0, [Validators.required]],
        LowThresoldValue: [0, [Validators.required]],
        Unit: ['NONE', Validators.required],
        Location: ['', Validators.required],
        RegisterSeq: [0],
        RegisterDataId: [0],
        DecimalPointForFront: ['', [Validators.required]],
        IsFromParameterConfig: [''],
        MultiplicationFactor: ['1.000', [Validators.required]],
        ZeroScale: [0],
        FullScale: [0],
        CommandNames: ['']
      })])
    });
    this.GetAlertList();
    setTimeout(() => {
      if (this.MeterConfigurationdata != null) {
        this.SetMeterConfigurationdata()
      }
      if (this.EnergyMeterdata != null && this.EnergyMeterID == 0) {
        this.SetRegisterData();
        this.IsChange = true;
        this.isSaved = false;
      }
      else if (this.EnergyMeterID > 0) {
        this.GetRegisterdata(this.EnergyMeterID);
        this.GetMeterConfigurationData(this.EnergyMeterID);
      }
    }, 2000);

    this.UserPrefData = JSON.parse(localStorage.getItem('UserPref'));
    if (this.UserPrefData) {
      this.minSlID = this.UserPrefData.filter(x => x.PrefKey == 'MinSlaveID')[0].PrefValue;
      this.maxSlID = this.UserPrefData.filter(x => x.PrefKey == 'MaxSlaveID')[0].PrefValue;
      this.MaximumRegister = this.DeviceProtocol == 'HTTP' ? this.UserPrefData.filter(x => x.PrefKey == 'HTTP')[0].PrefValue : this.UserPrefData.filter(x => x.PrefKey == 'FTP')[0].PrefValue;
    }

    this.registerpanelForm.valueChanges.subscribe(val => {
      if (this.isSaved == true) {
        this.IsChange = true;
      }
      if (this.genericValidator != undefined) {
        this.displayMessage = this.genericValidator.processMessages(this.registerpanelForm, false, this.validationMessages);
      }
    });
    this.RoleName = localStorage.getItem('RoleName');
  }

  OnImport() {
    if (this.EnergyMeterdata?.listRegisterdata?.length > 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '35%',
        data: { entityName: 'Register Config' },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'Y') {
          this.UploadExcelFile(); // open file upload dialog
        }
      });
    } else {
      this.UploadExcelFile(); // open file upload dialog directly
    }
  }
  UploadExcelFile(): void {
    this.showvalue = false
    const UploadLogodialogref = this.dialog.open(UploadFileComponent, {
      data: { isFromMeterConfig: 'Y' }
    });
    UploadLogodialogref.afterClosed().subscribe((result: any) => {

      if (!result || !Array.isArray(result)) {
        console.warn('Invalid data received from upload dialog');
        return;
      }

      // There is 2 types of data 1st is for registers configuration and 2nd is for other properties data so need to partition of that
      const formEntries = result.slice(0, 7);
      const headerEntry = result.find((entry: any) => entry.Field == 'RegisterName');
      const registerValueEntries = result.filter((entry: any) => entry.Field !== 'RegisterName' && !formEntries.includes(entry));

      // Create entryMap from form entries
      const entryMap: { [key: string]: any } = {};
      formEntries.forEach(entry => {
        entryMap[entry.Field] = entry.Value?.toString() ?? '';
      });

      // Reverse lookup: CodeDisplayName Ã¢â€ â€™ CodeValue
      const getCodeValueFromDisplay = (list: any[], displayName: string) => {
        const found = list.find(x => x.CodeDisplayName == displayName);
        return found ? found.CodeValue : displayName; // fallback to original if not matched
      };

      // Replace CodeDisplayName with CodeValue
      entryMap['ModbusRequestType'] = getCodeValueFromDisplay(this.ModbusRequestTypeList, entryMap['ModbusRequestType']);
      entryMap['DataReadSelection'] = getCodeValueFromDisplay(this.DataReadSelectionList, entryMap['DataReadSelection']);

      // Patch form values
      this.registerpanelForm.get('SlaveID')?.setValue(entryMap['SlaveID'] || '');
      this.registerpanelForm.get('MaxRegisters')?.setValue(entryMap['MaxRegisters'] || '');
      this.registerpanelForm.get('ReadRegisterQuantity')?.setValue(entryMap['ReadRegisterQuantity'] || '');
      this.registerpanelForm.get('MaxSlaveRecord')?.setValue(entryMap['MaxSlaveRecord'] || '');
      this.registerpanelForm.get('ModbusRequestType')?.setValue(entryMap['ModbusRequestType'] || '');
      this.registerpanelForm.get('StartRegisterNumber')?.setValue(entryMap['StartRegisterNumber'] || '');
      this.registerpanelForm.get('DataReadSelection')?.setValue(entryMap['DataReadSelection'] || '');

      // Control conditional flag
      this.showvalue = entryMap['ModbusRequestType'] == '1';

      // Update EnergyMeterdata object
      Object.assign(this.EnergyMeterdata, {
        MaxRegisters: entryMap['MaxRegisters'],
        SlaveID: entryMap['SlaveID'],
        ReadRegisterQuantity: entryMap['ReadRegisterQuantity'],
        MaxSlaveRecord: entryMap['MaxSlaveRecord'],
        ModbusRequestType: entryMap['ModbusRequestType'],
        StartRegisterNumber: entryMap['StartRegisterNumber'],
        DataReadSelection: entryMap['DataReadSelection'],
      });

      // Extract register headers
      const registerHeaders: string[] = [];

      // First push 'Field' and 'Value' keys
      registerHeaders.push(headerEntry.Field);  // 'RegisterName'
      registerHeaders.push(headerEntry.Value);  // 'RegisterNO'

      // Now loop over the remaining __EMPTY keys
      let index = 0;
      while (true) {
        const key = index == 0 ? '__EMPTY' : `__EMPTY_${index}`;
        const header = headerEntry[key];
        if (header == undefined) break;
        registerHeaders.push(header);
        index++;
      }

      // Fill FormArray
      const formArray = this.fb.array([]);

      registerValueEntries.forEach(data => {
        const group: { [key: string]: FormControl } = {};
        const element: any = {};

        for (let i = 0; i < registerHeaders.length; i++) {
          const key = registerHeaders[i];
          let value: any;

          if (i == 0) {
            value = data.Field; // RegisterName
          } else if (i == 1) {
            value = data.Value; // RegisterNO
          } else {
            const emptyKey = i == 2 ? '__EMPTY' : `__EMPTY_${i - 2}`;
            value = data[emptyKey];
          }
          element[key] = value;
        }

        // Bind to form controls of registers
        group['RegisterName'] = new FormControl(element?.RegisterName ?? '');
        group['RegisterNO'] = new FormControl(element?.RegisterNO ?? '');
        group['DataType'] = new FormControl(element?.DataType?.toString() ?? '');
        group['FunctionCode'] = new FormControl(element?.FunctionCode?.toString() ?? '');
        group['DecimalPoint'] = new FormControl(element?.DecimalPoint?.toString() ?? '0', [Validators.required]);
        group['ReadWriteAction'] = new FormControl(element?.ReadWriteAction?.toString() ?? '');
        group['IsDisplayGraph'] = new FormControl(element?.IsDisplayGraph?.toString().toLowerCase() == 'true');
        group['IsTotalizer'] = new FormControl(element?.IsTotalizer?.toString().toLowerCase() == 'true');
        group['AlertId'] = new FormControl(this.resolveAlertId(element), [Validators.required]);
        group['HighThresoldValue'] = new FormControl(element?.HighThresoldValue?.toString() ?? '');
        group['LowThresoldValue'] = new FormControl(element?.LowThresoldValue?.toString() ?? '');
        group['MultiplicationFactor'] = new FormControl(element?.MultiplicationFactor?.toString() ?? '');
        group['ZeroScale'] = new FormControl(element?.ZeroScale?.toString() ?? 0);
        group['FullScale'] = new FormControl(element?.FullScale?.toString() ?? 0);
        group['RegisterSeq'] = new FormControl(element?.RegisterSeq?.toString() ?? 0);
        group['Unit'] = new FormControl(element?.Unit ?? '');
        group['Location'] = new FormControl(element?.Location?.toString() ?? '');
        group['RegisterDataId'] = new FormControl(0);
        group['DecimalPointForFront'] = new FormControl(element?.DecimalPointForFront?.toString() ?? '');
        group['IsFromParameterConfig'] = new FormControl(element?.IsFromParameterConfig ?? 'N');
        group['CommandNames'] = new FormControl(element?.CommandNames ?? '');
        formArray.push(this.fb.group(group));
      });

      const legacyAlertEntry = result.find((entry: any) => entry.Field === 'AlertId');
      const legacyAlertId = legacyAlertEntry?.Value?.toString() ?? '';
      if (legacyAlertId) {
        formArray.controls.forEach((ctrl) => {
          const alertCtrl = ctrl.get('AlertId');
          if (alertCtrl) {
            alertCtrl.patchValue(this.normalizeAlertId(legacyAlertId));
          }
        });
      }

      this.registerpanelForm.setControl('listRegisterdata', formArray);
      this.applyDefaultAlertIdsToRows();
      this.EnergyMeterdata.listRegisterdata = formArray
    });
  }

  GetRegisterdata(id) {
    if (id != null) {
      this.GSMConfigService.GetRegisterdata(id, 'N', 'N', '').subscribe(
        (result) => {
          if (result != null) {
            this.EnergyMeterdata = result;
            this.energyListOfPopup = result.listRegisterdata
            this.SetRegisterData();
            this.IsChange = false;
            this.isSaved = true;
          }
          this.selectedmeterid = id
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }
  GetMeterConfigurationData(id) {
    if (id != null) {
      this.GSMConfigService.GetMeterConfigurationData(id).subscribe(
        (result) => {
          if (result != null) {
            this.MeterConfigurationdata = result;
            this.deviceSettingsForm.patchValue({
              EnergymeterMasterID: this.EnergyMeterID,
              SerialNumber: this.MeterConfigurationdata.SerialNumber,
              LastCalibrationDate: this.MeterConfigurationdata.LastCalibrationDate,
              LastCalibrationDueDate: this.MeterConfigurationdata.LastCalibrationDueDate,
            });
            this.CalibrationCertificatefilename = this.MeterConfigurationdata.CalibrationCertificate
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }
  SetMeterConfigurationdata() {

    this.deviceSettingsForm.patchValue({
      EnergymeterMasterID: this.EnergyMeterID,
      SerialNumber: this.MeterConfigurationdata.SerialNumber,
      LastCalibrationDate: this.MeterConfigurationdata.LastCalibrationDate,
      LastCalibrationDueDate: this.MeterConfigurationdata.LastCalibrationDueDate,
    });
    this.CalibrationCertificatefilename = this.MeterConfigurationdata.CalibrationCertificate
  }

  SetRegisterData() {
    this.flag = false;
    const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];


    this.registerpanelForm.patchValue({
      EnergymeterMasterID: this.EnergyMeterID,
      SlaveID: this.EnergyMeterdata?.SlaveID,
      MaxRegisters: this.EnergyMeterdata?.MaxRegisters,
      ModbusRequestType: this.EnergyMeterdata?.ModbusRequestType == 1 ? "1" : '0',
      StartRegisterNumber: this.EnergyMeterdata?.StartRegisterNumber ? this.EnergyMeterdata?.StartRegisterNumber : 0,
      ReadRegisterQuantity: this.EnergyMeterdata?.ReadRegisterQuantity ? this.EnergyMeterdata?.ReadRegisterQuantity : 0,
      MaxSlaveRecord: this.EnergyMeterdata?.MaxSlaveRecord ? this.EnergyMeterdata?.MaxSlaveRecord : 0,
      DataReadSelection: this.EnergyMeterdata?.DataReadSelection == 1 ? "1" : '0',
    });
    this.EnergyMeterdata?.ModbusRequestType == 1 ? this.showvalue = true : false

    if (this.EnergyMeterdata?.ModbusRequestType) {
      this.EnergyMeterdata?.ModbusRequestType.toString() == 1 ? this.showvalue == true : false
    }
    control.clear();
    if (this.energyListOfPopup) {
      let controlIndex = 0; // Separate counter for controls
      this.energyListOfPopup.forEach((element) => {

        if (element?.TagId != "DataCount") {
          // IF there is not registers in that case download button's lable need to change so for that use this work
          if (element.RegisterDataId > 0) {
            this.registeravailableornot = true
          }
          control.push(
            this.form.group({
              RegisterName: new FormControl(element?.RegisterName, [Validators.required]),
              RegisterNO: new FormControl(element.RegisterNO != null ? element?.RegisterNO : 1,
                [Validators.required]),
              DataType: new FormControl(element?.DataType ? element?.DataType.toString() : '0', [Validators.required]),
              FunctionCode: new FormControl(element?.FunctionCode ? element?.FunctionCode.toString() : '1', [Validators.required]),
              DecimalPoint: new FormControl(element?.DecimalPoint ? element?.DecimalPoint.toString() : '0', [Validators.required]),
              ReadWriteAction: new FormControl(element?.ReadWriteAction ? element?.ReadWriteAction.toString() : '0', [Validators.required]),
              IsDisplayGraph: new FormControl(element?.IsDisplayGraph ? (element?.IsDisplayGraph.toString() == 'true') ? true : false : false),
              IsTotalizer: new FormControl(element?.IsTotalizer ? (element?.IsTotalizer.toString() == 'true') ? true : false : false),
              AlertId: new FormControl(this.resolveAlertId(element), [Validators.required]),
              HighThresoldValue: new FormControl(element?.HighThresoldValue ? element?.HighThresoldValue : 0, [Validators.required]),
              LowThresoldValue: new FormControl(element?.LowThresoldValue ? element?.LowThresoldValue : 0, [Validators.required]),
              MultiplicationFactor: new FormControl(element?.MultiplicationFactor ? element?.MultiplicationFactor : 0, [Validators.required]),
              ZeroScale: new FormControl(element?.ZeroScale ? element?.ZeroScale : 0),
              FullScale: new FormControl(element?.FullScale ? element?.FullScale : 0),
              RegisterSeq: element?.RegisterSeq ? element?.RegisterSeq : 0,
              Unit: new FormControl(element?.Unit ? element?.Unit : 'NONE', [Validators.required]),
              Location: new FormControl(element?.Location ? element?.Location : ' ', [Validators.required]),
              RegisterDataId: element?.RegisterDataId,
              DecimalPointForFront: new FormControl(element?.DecimalPointForFront ? element?.DecimalPointForFront.toString() : '0', [Validators.required]),
              IsFromParameterConfig: this.newdata?.IsFromParameterConfig ? this.newdata?.IsFromParameterConfig : element?.IsFromParameterConfig,
              Formula: element?.Formula,
              TagId: element?.TagId,
              TempFormula: element?.TempFormula,
              CommandNames: element?.CommandNames
            })
          );
          let getdatatypename: any = this.FunctionCodeList.find((item: any) => item.CodeValue == element?.FunctionCode.toString());
          if (getdatatypename?.CodeValue == '1') {
            control.at(controlIndex).get('CommandNames')?.enable();
          } else {
            control.at(controlIndex)?.get('CommandNames')?.disable();
          }
          controlIndex++; // Increment the control index only when an item is added
        }
      });
    }

    this.applyDefaultAlertIdsToRows();
    this.normalizeUnitValues();
  }

  normalizeUnitValues(): void {
    if (!this.UnitList?.length || !this.registerpanelForm?.get('listRegisterdata')) {
      return;
    }
    const rows = this.registerpanelForm.get('listRegisterdata') as FormArray;
    rows.controls.forEach((row: FormGroup) => {
      const unitControl = row.get('Unit');
      const current = unitControl?.value;
      if (current == null || current === '') {
        return;
      }
      const match = this.UnitList.find((item: any) =>
        item.CodeDisplayName === current || String(item.CodeValue) === String(current)
      );
      if (match) {
        unitControl.patchValue(match.CodeDisplayName, { emitEvent: false });
      }
    });
  }
  Getdropdownlist() {
    let reqpara = 'DataType,FunctionCode,DecimalPoint,ReadWriteAction,DecimalPointForFront,ModbusRequestType,DataReadSelection,Units';
    this.GSMConfigService.Getdropdownlist(reqpara).subscribe(
      (result) => {
        this.DropDownList = result;
        this.DatatypeList = this.DropDownList['listDataType'];
        this.FunctionCodeList = this.DropDownList['listFunctionCode'];
        this.DecimalPointList = this.DropDownList['listDecimalPoint'];
        this.ActionList = this.DropDownList['listaction'];
        this.DecimalPointFrontList = this.DropDownList['listDecimalPointForFront'];
        this.ModbusRequestTypeList = this.DropDownList['listModbusRequestType'];
        this.DataReadSelectionList = this.DropDownList['listDataReadSelection'];
        this.UnitList = this.DropDownList['listUnits'] || [];
        this.normalizeUnitValues();
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  GetAlertList() {
    this.alertMasterService.GetAlertList({ AlertName: '', Severity: '' }).subscribe(
      (result) => {
        if (result && Array.isArray(result.AlertMasterLists) && result.AlertMasterLists.length > 0) {
          this.AlertList = result.AlertMasterLists;
          this.applyDefaultAlertIdsToRows();
        } else {
          this.AlertList = [];
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }
  // on change all dropdown List
  OnChange(type, index) {
    const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];
    if (control.status == 'INVALID') {
      control.value.forEach((element, i) => {
        var listdata = (this.registerpanelForm.get('listRegisterdata') as FormArray).at(i);

        if (type == 'dataType') {

          if (control.value[i].DataType == '') {
            listdata.get('DataType').patchValue(control.value[0].DataType);
          }
        }
        if (type == 'FunctionCode') {
          if (control.value[i].FunctionCode == '') {
            listdata.get('FunctionCode').patchValue(control.value[0].FunctionCode);
          }
        }
        if (type == 'DecimalPoint') {
          if (control.value[i].DecimalPoint == '') {
            listdata.get('DecimalPoint').patchValue(control.value[0].DecimalPoint);
          }
        }
        if (type == 'DecimalPointForFront') {
          if (control.value[i].DecimalPointForFront == '') {
            listdata.get('DecimalPointForFront').patchValue(control.value[0].DecimalPointForFront);
          }
        }
        if (type == 'ReadWriteAction') {
          if (control.value[i].ReadWriteAction == '') {
            listdata.get('ReadWriteAction').patchValue(control.value[0].ReadWriteAction);
          }
        }
      });
    }
    else {
      if (type == 'FunctionCode') {
        const getdatatypename: any = this.FunctionCodeList.filter((item: any) => item.CodeValue == control.value[0].FunctionCode)[0];
        if (getdatatypename.CodeValue == '1') {
          control.at(index).get('CommandNames').enable();
        }
        else {
          control.at(index).get('CommandNames').disable();
        }
      }
    }
  }

  OnShow(value) {
    const divElement = document.getElementById('divToRemove');
    if (divElement) {
      divElement.parentNode.removeChild(divElement);
    }
    this.flag = false;
    this.numberOfRegister = value;
    const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];

    if (control.length < this.numberOfRegister) {
      for (let i = control.length; i < this.numberOfRegister; i++) {
        control.push(this.AddMaxRegisterdata(i));
      }
    }
    else {
      for (let i = control.length; i >= this.numberOfRegister; i--) {
        control.removeAt(i);
      }
    }
    this.EnergyMeterdata.MaxRegisters = value
    this.applyDefaultAlertIdsToRows();
  }

  AddMaxRegisterdata(index) {
    return this.fb.group({
      RegisterName: ['', [Validators.required]],
      RegisterNO: ['', [Validators.required]],
      DataType: ['', [Validators.required]],
      FunctionCode: ['', [Validators.required]],
      DecimalPoint: ['', [Validators.required]],
      ReadWriteAction: ['', [Validators.required]],
      IsDisplayGraph: [''],
      IsTotalizer: [''],
      AlertId: [this.defaultAlertId, [Validators.required]],
      HighThresoldValue: [0, [Validators.required]],
      LowThresoldValue: [0, [Validators.required]],
      MultiplicationFactor: [0, [Validators.required]],
      FullScale: [0],
      ZeroScale: [0],
      Unit: ['NONE', [Validators.required]],
      Location: ['', [Validators.required]],
      RegisterSeq: index,
      RegisterDataId: [0],
      DecimalPointForFront: ['', [Validators.required]],
      IsFromParameterConfig: 'N',
      Formula: '',
      TagId: '',
      TempFormula: '',
      CommandNames: ''
    });
  }

  OnSubmit() {
    this.isSaveClick = true;
    if (this.registerpanelForm.get('listRegisterdata').invalid) {
      this.errorMsg = 'Need to fill all fields of Register Data List !!';
      this.successMsg = ''
      return;
    }

    if (this.registerpanelForm.value.ModbusRequestType == null || this.registerpanelForm.value.ModbusRequestType == '') {
      this.displayMessage = this.genericValidator.processMessages(this.registerpanelForm, true, this.validationMessages);
      return
    }
    if ((this.registerpanelForm.value.ModbusRequestType == "1") && (this.registerpanelForm.value.SlaveID == null || this.registerpanelForm.value.MaxRegisters == null)) {
      this.registerpanelForm.updateValueAndValidity();
      this.registerpanelForm.markAllAsTouched();

      this.displayMessage = this.genericValidator.processMessages(this.registerpanelForm, true, this.validationMessages);
      return;
    } else if ((this.registerpanelForm.value.ModbusRequestType == "0") && (this.registerpanelForm.value.SlaveID == null || this.registerpanelForm.value.MaxRegisters == null)) {
      this.registerpanelForm.updateValueAndValidity();
      this.registerpanelForm.markAllAsTouched();

      this.displayMessage = this.genericValidator.processMessages(this.registerpanelForm, true, this.validationMessages);
      return;
    }
    if ((this.EnergyMeterdata.MaxRegisters) != (this.registerpanelForm.value.listRegisterdata.length)) {

      this.errorMsg = 'No. of registers in the list should be same as Max. Register Field !!';
      return;
    }

    if ((this.registerpanelForm.value.ModbusRequestType == "0")) {
      this.registerpanelForm.value.ReadRegisterQuantity = 0
      this.registerpanelForm.value.StartRegisterNumber = 0
    }

    this.ValidateFields('SlaveID');
    this.ValidateFields('Register');
    const objdevice = {
      SerialNumber: this.deviceSettingsForm.value.SerialNumber,
      LastCalibrationDate: this.deviceSettingsForm.value.LastCalibrationDate
        ? [formatDate(this.deviceSettingsForm.value.LastCalibrationDate, 'yyyy-MM-dd', 'en')][0]
        : null,
      LastCalibrationDueDate: this.deviceSettingsForm.value.LastCalibrationDueDate
        ? [formatDate(this.deviceSettingsForm.value.LastCalibrationDueDate, 'yyyy-MM-dd', 'en')][0]
        : null,
      CalibrationCertificate: this.CalibrationCertificatefilename,
      EnergymeterMasterId: this.EnergyMeterID ? this.EnergyMeterID : 0,

      UserId: localStorage.getItem("UserId")
    };
    this.meterConfiguration = objdevice

    if (this.SlaveMessage == '' && this.MaxRegister == '') {
      let reqparam = { ...this.registerpanelForm.value };
      this.RegisterDataparam = reqparam
      if (this.EnergyMeterID > 0) {
        this.SaveRegisterData(reqparam);
      }
      else {
        var obj = {
          RegisterData: this.RegisterDataparam,
          meterConfiguration: this.meterConfiguration
        }
        this.dialogRef.close(obj);
      }
      this.IsChange = false;
      // this.dialogRef.close(reqparam);
    }
    else {
      return;
    }
  }

  DownloadSampleExcel() {
    // If there is registers so in that case current registers configuration will be downloaded
    if (this.registeravailableornot) {
      const formValue = this.registerpanelForm.value;

      // There are some fields that are not in register list need to set 
      const staticFields = [
        'SlaveID',
        'MaxRegisters',
        'ReadRegisterQuantity',
        'MaxSlaveRecord',
        'ModbusRequestType',
        'StartRegisterNumber',
        'DataReadSelection',
      ];

      const registerData = formValue.listRegisterdata || [];
      const newregisterData = registerData.filter(item => item.IsFromParameterConfig != 'Y');

      //  Dynamically set MaxRegisters based on filtered data
      formValue['MaxRegisters'] = newregisterData.length;

      // Build combined data
      const combinedData: any[][] = [];
      combinedData.push(['Field', 'Value']); // Header row

      staticFields.forEach(field => {
        let value = formValue[field] ?? '';

        // Set to 0 if value is null, undefined, or empty string
        if (value == null || value == undefined || value == '') {
          value = 0;
        }
        // Handle special cases
        if (field === 'ModbusRequestType') {
          const matched = this.ModbusRequestTypeList.find(x => x.CodeValue == value);
          value = matched ? matched.CodeDisplayName : value;
        }

        if (field === 'DataReadSelection') {
          const matched = this.DataReadSelectionList.find(x => x.CodeValue == value);
          value = matched ? matched.CodeDisplayName : value;
        }

        combinedData.push([field, value]);
      });

      // Add blank row
      combinedData.push([]);

      //  To add Register Data in file


      const requiredKeys = [
        'RegisterName',
        'RegisterNO',
        'Unit',
        'Location',
        'CommandNames',
        'DataType',
        'FunctionCode',
        'DecimalPoint',
        'DecimalPointForFront',
        'ReadWriteAction',
        'IsDisplayGraph',
        'IsTotalizer',
        'AlertId',
        'HighThresoldValue',
        'LowThresoldValue',
        'MultiplicationFactor',
      ];

      // Add header row for register data
      combinedData.push(requiredKeys);
      // Add register rows

      newregisterData.forEach(item => {
        const row = requiredKeys.map(key => item[key] ?? '');
        combinedData.push(row);
      });

      // Create Workbook
      const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(combinedData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'RMS_Meter_Configuration');

      // Export to Excel
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob: Blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      // Trigger download
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'RMS_Meter_Configuration.xlsx';
      link.click();
    }
    // If there is no register available in that case by default file will be downloaded
    else {
      let serviceCallURL: string = this.configService.serviceUrl('ServiceURLDownload') + 'usermanual' + '/RMS_Meter_Configuration.xlsx'
      window.open(serviceCallURL);
    }
  }

  // Save Register Data
  SaveRegisterData(requestparam) {
    this.errorMsg = '';
    this.successMsg = '';
    this.GSMConfigService.SaveRegisterData(requestparam).subscribe(
      (result) => {
        if (result) {
          this.successMsg = 'Values Submitted Successfully';
          this.errorMsg = ''
          this.isSaveClick = false;
        }

      },
      (error) => {
        this.errorMsg = error;
        this.successMsg = ''
      });
  }

  OnCancel() {
    this.dialogRef.close();
  }

  Close() {
    this.dialogRef.close();
  }

  // On Key Press Event
  onKeypressEvent(event, Type) {
    this.ValidateFields(Type);
  }

  // Validate Fields
  ValidateFields(Type) {
    var realValue = '';
    if (Type == 'SlaveID') {
      realValue = this.registerpanelForm.value.SlaveID;
      if (+realValue > this.maxSlID || +realValue < this.minSlID) {
        this.SlaveMessage = 'Greater than ' + this.minSlID + ' and less than ' + this.maxSlID;
        return;
      }
      else {
        this.SlaveMessage = '';
      }
    }
    else if (Type == 'Register') {
      realValue = this.registerpanelForm.value.MaxRegisters;
      if (+realValue > this.MaximumRegister) {
        this.MaxRegister = 'Less than or equal to ' + this.MaximumRegister;
        return;
      }
      else {
        this.MaxRegister = '';
      }
    }
  }

  float2int(value) {
    return value | 0;
  }

  // Send Register JSON creation function
  SendRegisterJSON() {
    // from Unit List fetch its value based on Unit Name; keep custom typed unit as-is
    this.registerpanelForm.value.listRegisterdata.forEach((value: any) => {
      var unitcode = this.UnitList.filter(f => f.CodeDisplayName == value.Unit);
      if (unitcode.length > 0) {
        value.Unit = unitcode[0].CodeValue
      }
    });

    // Assign required data to variable to use create JSON as per format
    var MaxRegister = this.registerpanelForm.value.MaxRegisters;
    var SlaveID = this.registerpanelForm.value.SlaveID;
    var ReadRegisterQuantity = this.registerpanelForm.value.ReadRegisterQuantity;
    var MaxSlaveRecord = this.registerpanelForm.value.MaxSlaveRecord;
    var StartRegisterNumber = this.registerpanelForm.value.StartRegisterNumber;
    var ModbusRequestType = this.registerpanelForm.value.ModbusRequestType;
    var DataReadSelection = this.registerpanelForm.value.DataReadSelection;
    var Reqest_no = 0;
    var index = 0;

    var Total_length = this.registerpanelForm.value.listRegisterdata.length;
    // There is bunch of 10 data so here need to prepare total request count based on registers list
    var Total_req = this.float2int(Total_length / 10);

    if ((Total_length % 10) != 0) {
      Total_req += 1;
    }

    // Here this.List have 10 alphabets list so here cont setted 10
    var cont = 10;
    if (Total_length < cont) {
      cont = Total_length;
    }

    // Based on Total request count make data via loop
    for (var j = 0; j < Total_req; j++) {
      this.ReqObj[Reqest_no] = { 'Topic': 9003 + Reqest_no, 'MREQ': MaxRegister };
      this.ReqObj[Reqest_no]['DEVID'] = this.EMIndex + 1;
      this.ReqObj[Reqest_no]['SID'] = SlaveID;
      this.ReqObj[Reqest_no]['REQ_RDTY'] = ModbusRequestType;
      this.ReqObj[Reqest_no]['STR_REG'] = StartRegisterNumber;
      this.ReqObj[Reqest_no]['R_TYPE'] = DataReadSelection;
      this.ReqObj[Reqest_no]['REG_QTY'] = ReadRegisterQuantity;
      this.ReqObj[Reqest_no]['SLV_STACK'] = MaxSlaveRecord;
      // stake slave new add karvanu input field number 
      var CharIndex = 0;
      for (var i = index; i < cont; i++) {
        if (MaxRegister > i) {

          var ReqRNo = this.List[CharIndex];
          var ReqRFields = this.List[CharIndex] + '1';
          var ReqRFields2 = this.List[CharIndex] + '2';
          var ReqRFields3 = this.List[CharIndex] + '3';

          this.ReqObj[Reqest_no][ReqRNo] = this.registerpanelForm.value.listRegisterdata[i].RegisterNO;
          this.ReqObj[Reqest_no][ReqRFields] = this.registerpanelForm.value.listRegisterdata[i].DataType + '/' + this.registerpanelForm.value.listRegisterdata[i].FunctionCode + '/' + this.registerpanelForm.value.listRegisterdata[i].DecimalPoint + '/'
            + this.registerpanelForm.value.listRegisterdata[i].ReadWriteAction;
          this.ReqObj[Reqest_no][ReqRFields2] = this.registerpanelForm.value.listRegisterdata[i].MultiplicationFactor
          this.ReqObj[Reqest_no][ReqRFields3] = this.registerpanelForm.value.listRegisterdata[i].HighThresoldValue
        }

        CharIndex += 1;
      }
      // Here previous cont will be setted in index for start from previous in next loop
      index = cont;
      //Here based on registers length new cont will be setted, otherwise need to add by 10
      // Change : Bhavy Shah : Here need to assign cont value based on registers length and previous cont value
      cont = RName_length < cont ? RName_length : cont + 10;
      // Increment by 1 for request number to add via loop
      Reqest_no += 1;

    }
    var RName_length = this.registerpanelForm.value.listRegisterdata.length;
    var Total_req = this.float2int(RName_length / 10);
    if ((RName_length % 10) != 0) {
      Total_req += 1;
    }

    var cont = 10;
    if (RName_length < cont) {
      cont = RName_length;
    }
    // Fetch all register data to create JSON as per format
    var regisetrData = this.registerpanelForm.value.listRegisterdata;
    var index = 0;
    var Reqest_no = 0;
    for (var j = 0; j < Total_req; j++) {
      this.RNameObj[Reqest_no] = { "Topic": 10001 + Reqest_no };
      this.RNameObj[Reqest_no]["DEVID"] = this.EMIndex + 1;
      var CharIndex = 0;

      for (var k = index; k < cont; k++) {
        var ReqRNo = this.List[CharIndex];
        var ReqUnit = this.List[CharIndex] + '1';
        var ReqLocation = this.List[CharIndex] + '2';
        if (regisetrData[k] != undefined)
          // Here RegisterName is replaced with TagId in this.RNameObj[Reqest_no][ReqRNo]
          // Changes : Bhavy Shah : Here Register name is replaced with Tag Id
          this.RNameObj[Reqest_no][ReqRNo] = regisetrData[k]?.TagId;
        this.RNameObj[Reqest_no][ReqUnit] = regisetrData[k]?.Unit;
        this.RNameObj[Reqest_no][ReqLocation] = regisetrData[k]?.Location;
        CharIndex += 1;
      }
      // Here previous cont will be setted in index for start from previous in next loop
      index = cont;
      //Here based on registers length new cont will be setted, otherwise need to add by 10
      // Change : Bhavy Shah : Here need to assign cont value based on registers length and previous cont value
      cont = RName_length < cont ? RName_length : cont + 10;
      // Increment by 1 for request number to add via loop
      Reqest_no += 1;
    }
    var data = [];
    for (i = 0; i < Total_req; i++) {
      var reqObj = {
        Topic: this.KeyID,
        PublishMessageJson: JSON.stringify(this.RNameObj[i])
      }
      data.push(reqObj);
    }
    for (i = 0; i < Total_req; i++) {
      var reqObj = {
        Topic: this.KeyID,
        PublishMessageJson: JSON.stringify(this.ReqObj[i])
      }
      data.push(reqObj);
    }
    var reqobj = {
      Data: data
    }
    // Function to send data via MQTT
    this.SendDatabyMQTT(reqobj);
  }

  // MQTT senddata function
  SendDatabyMQTT(reqObj) {
    this.errorMsg = '';
    this.successMsg = '';
    this.mqttoperation.PublishdatabyMQTT(reqObj).subscribe(
      (result: any) => {
        if (result == '0') {
          this.successMsg = 'Configuration value submitted successfully';
          this.errorMsg = ''
        }
        else {
          this.errorMsg = 'There are ' + result + ' requests are pending to acknowledge from device.';
          this.successMsg = ''
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  AddNewParameterConfig(ParameterConfigId, index) {
    if (this.data.EnergyMeterdata.EMID == 0) {
      this.isDivVisible = true;
    }
    else {
      const dashboardconfig = this.dialog.open(AddnewparameterconfigComponent, {
        width: '700px',
        height: '400px',
        data: {
          data: ParameterConfigId, 'selectedmetername': this.selectedmetername, 'id': this.selectedmeterid,
          IsForview: 'N', 'otherdata': this.newdata
        },
        disableClose: true
      })
      dashboardconfig.afterClosed().subscribe(
        (result) => {
          if (ParameterConfigId != 0) {
            this.energyListOfPopup.push(result)

            this.registerpanelForm['controls'].listRegisterdata['controls'][index]['controls'].RegisterName.patchValue(result.RegisterName);
            this.registerpanelForm['controls'].listRegisterdata['controls'][index]['controls'].Formula.patchValue(result.Formula);
            this.registerpanelForm['controls'].listRegisterdata['controls'][index]['controls'].TagId.patchValue(result.TagId);
            this.registerpanelForm['controls'].listRegisterdata['controls'][index]['controls'].TempFormula.patchValue(result.TempFormula);
          }
          this.newdata = result

          if (ParameterConfigId == 0) {
            const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];

            control.push(
              this.form.group({
                RegisterName: new FormControl(result.RegisterName, [Validators.required]),
                RegisterNO: new FormControl(1, [Validators.required]),
                DataType: new FormControl('0', [Validators.required]),
                FunctionCode: new FormControl('1', [Validators.required]),
                DecimalPoint: new FormControl('0', [Validators.required]),
                ReadWriteAction: new FormControl('0', [Validators.required]),
                IsDisplayGraph: new FormControl(result?.IsDisplayGraph ? (result?.IsDisplayGraph.toString() == 'true') ? true : false : false),
                IsTotalizer: new FormControl(result?.IsTotalizer ? (result?.IsTotalizer.toString() == 'true') ? true : false : false),
                AlertId: new FormControl(this.defaultAlertId, [Validators.required]),
                HighThresoldValue: new FormControl(0, [Validators.required]),
                LowThresoldValue: new FormControl(0, [Validators.required]),
                MultiplicationFactor: new FormControl(0, [Validators.required]),
                ZeroScale: new FormControl(0),
                FullScale: new FormControl(0),
                RegisterSeq: (result?.RegisterSeq ? result?.RegisterSeq : 0),
                Unit: new FormControl('NONE', [Validators.required]),
                Location: new FormControl(0, [Validators.required]),
                RegisterDataId: result?.RegisterDataId,
                DecimalPointForFront: new FormControl('0', [Validators.required]),
                IsFromParameterConfig: result.IsFromParameterConfig,
                Formula: result.Formula,
                TagId: result.TagId,
                TempFormula: result.TempFormula,
                CommandNames: result.CommandNames
              })
            );

            this.EnergyMeterdata.MaxRegisters = parseInt(this.EnergyMeterdata.MaxRegisters) + 1

            this.registerpanelForm.patchValue({
              MaxRegisters: this.EnergyMeterdata.MaxRegisters
            });
          }
        }
      );
    }
  }

  DeleteParamterData(event: any, index) {
    this.errorMsg = '';
    this.successMsg = '';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '35%',
      disableClose: true

    })
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result == 'Y') {
          const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];
          if (index >= 0) {
            control.removeAt(index);
            this.EnergyMeterdata.MaxRegisters = parseInt(this.EnergyMeterdata.MaxRegisters) - 1
            this.registerpanelForm.patchValue({
              MaxRegisters: this.EnergyMeterdata.MaxRegisters
            });
          }
        }
      }
    );
  }
  changeModbusRequestType(event: any) {
    if (event.value == '1') {
      this.showvalue = true
    }
    else {
      this.showvalue = false
    }
  }

  //Call on Upload File click
  UploadCalibrationCertificate() {
    this.errorMsgdevice = ""
    this.successMsgdevice = ""

    const UploadLogodialogref = this.dialog.open(UploadFileComponent, {
      width: '70%',
      height: '40%',
      data: {
        MeterId: this.EnergyMeterID ? this.EnergyMeterID : 0
      }
    });

    //Callback on close popup and assign values
    UploadLogodialogref.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.CalibrationCertificatefilename = result;
        }
      })
  }
  SaveDeviceSettings() {
    this.errorMsgdevice = "";
    this.successMsgdevice = "";

    const obj = {
      SerialNumber: this.deviceSettingsForm.value.SerialNumber,
      LastCalibrationDate: this.deviceSettingsForm.value.LastCalibrationDate
        ? [formatDate(this.deviceSettingsForm.value.LastCalibrationDate, 'yyyy-MM-dd', 'en')][0]
        : null,
      LastCalibrationDueDate: this.deviceSettingsForm.value.LastCalibrationDueDate
        ? [formatDate(this.deviceSettingsForm.value.LastCalibrationDueDate, 'yyyy-MM-dd', 'en')][0]
        : null,
      CalibrationCertificate: this.CalibrationCertificatefilename,
      EnergymeterMasterId: this.EnergyMeterID ? this.EnergyMeterID : 0,
      UserId: localStorage.getItem("UserId")
    };
    this.meterConfiguration = obj

    // Array to collect error messages
    const missingFields: string[] = [];

    // Check each field and add to error message if missing
    if (!obj.SerialNumber) {
      missingFields.push("Serial Number");
    }
    if (!obj.LastCalibrationDate) {
      missingFields.push("Last Calibration Date");
    }
    if (!obj.LastCalibrationDueDate) {
      missingFields.push("Last Calibration Due Date");
    }
    if (!obj.CalibrationCertificate) {
      missingFields.push("Calibration Certificate");
    }

    // If any fields are missing, set the error message
    if (missingFields.length > 0) {
      this.errorMsgdevice = `Please fill out the following field(s): ${missingFields.join(", ")}.`;
      return; // Exit the function if validation fails
    }

    if (this.EnergyMeterID > 0) {
      this.SaveMeterConfigurationData(obj);
    }
    else {
      let reqparam = { ...this.registerpanelForm.value };
      this.RegisterDataparam = reqparam
      var objclose = {
        RegisterData: this.RegisterDataparam,
        meterConfiguration: this.meterConfiguration
      }
      this.dialogRef.close(objclose);
    }
  }
  SaveMeterConfigurationData(obj) {
    this.errorMsgdevice = ""
    this.successMsgdevice = ""
    this.GSMConfigService.SaveMeterConfigurationData(obj).subscribe(
      (result: any) => {
        if (result) {
          this.successMsgdevice = "Device settings saved successfully!";
        }
      },
      (error) => {
        this.errorMsgdevice = error;
      }
    );
  }
}
